module.exports = __webpack_public_path__ + "img/dummy-profile-image.85c5f288.png";